import { render, staticRenderFns } from "./html.vue?vue&type=template&id=9904c0ea&scoped=true"
import script from "./html.vue?vue&type=script&lang=ts"
export * from "./html.vue?vue&type=script&lang=ts"
import style0 from "./html.vue?vue&type=style&index=0&id=9904c0ea&prod&scoped=true&lang=css"
import style1 from "./html.vue?vue&type=style&index=1&id=9904c0ea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9904c0ea",
  null
  
)

export default component.exports